export default "__VITE_ASSET__CxdJjrTC__"